export default __webpack_public_path__ + "static/media/jowar.dfe7ec9b.png";